<template>
  <div class="rooms">
    <RoomsC />
  </div>
</template>

<script>
import RoomsC from "../components/Rooms/RoomsC.vue";

export default {
  name: "Rooms",
  components: { RoomsC },
};
</script>

<style>
</style>